/*
  Provides the static content for the current page
*/

import { WholesaleTypeName } from "psims/models/ref-data/wholesale-type";
import { useMemo } from "react";
import CONTENT_MAP from "./page-content";

interface UseContentForTypeProps {
    typeName: WholesaleTypeName | 'Submit';
}

function useContentForType({typeName}: UseContentForTypeProps) {
    const content = useMemo(() => {
        return CONTENT_MAP[typeName];
    }, [typeName]);

    return content;
}

export default useContentForType;
